import React, { useEffect, useRef, useState, useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { APICall } from "../../../Helpers/API/APICalls";
import {
  GetAppLifeCycDropDown,
  GetDropDownList,
  GetEmployeeDropdownData,
  GetKRADetailsBasedOnId,
  GetKraTypeDropdownData,
  InsertKRADetails,
} from "../../../Helpers/API/APIEndPoints";
import SelectForm from "../../../Components/SelectForm/SelectForm";
import InputForm from "../../../Components/InputForm/InputForm";
import Heading from "../../../Components/Heading/Heading";
import { getContext, LoaderContext } from "../../../Helpers/Context/Context";
import notify from "../../../Helpers/ToastNotification";

interface LocationState {
  employeeId: number;
  compOffdate: any;
  id: number;
  kraHeading: string;
  kraDescription: string;
  appraisalCycleId: number;
  kraTypeId: number;
  isDisable: boolean;
}
const KRAMaster = () => {
  const { showLoader, hideLoader } = useContext(LoaderContext);
  let navigate = useNavigate();
  const location = useLocation();

  const { EmployeeId, RoleId } = getContext();
  const RoleIdArray = RoleId.split(",");
  const state = location.state as LocationState;
  const [kraTitle, setKraTitle] = useState("");

  const [employee, setEmployee] = useState(null);
  const [employeeOption, setEmployeeOption] = useState([]);

  const [type, setType] = useState(null);
  const [typeOption, setTypeOption] = useState([]);

  const [appCycle, setAppCycle] = useState(null);
  const [appCycleOption, setAppCycleOption] = useState([]);

  const [Description, setDescription] = useState<any>("");
  const [formErrors, setFormErrors] = useState<any>({});

  const [isActive, setIsActive] = useState(true);
  const [isDisable, setIsDisable] = useState(
    state && state.isDisable ? true : false
  );

  const [env, setEnv] = useState<any>(
    process.env.REACT_APP_PUBLISH_PATH ? process.env.REACT_APP_PUBLISH_PATH : ""
  );

  useEffect(() => {
    ApprisalDropdown();
    typeDropdown();
    EmployeeDropdown();
  }, []);

  // Get KRA data based on Id
  const fetchKRADetails = async (
    id,
    RoleIdArray,
    appCycleOption,
    typeOption,
    employeeOption
  ) => {
    const responseData = await APICall(GetKRADetailsBasedOnId, "POST", {
      Id: id,
    });

    if (responseData.status === 0 && responseData.data !== null) {
      setKraTitle(responseData.data.kraHeading);
      setDescription(responseData.data.kraDescription);
      setIsActive(responseData.data.isActive);

      // Employee Start
      const selectedEmp = employeeOption.find(
        (option) => option.value === responseData.data.employeeId
      );
      if (
        (selectedEmp && RoleIdArray.includes("3")) ||
        RoleIdArray.includes("4")
      ) {
        setEmployee(selectedEmp);
        setIsDisable(false);
      } else if (selectedEmp && RoleIdArray.includes("8")) {
        setEmployee(selectedEmp);
        setIsDisable(true);
      }
      // Employee End

      const selectedCycle = appCycleOption.find(
        (option) => option.value === responseData.data.appraisalCycleId
      );
      if (selectedCycle) {
        setAppCycle(selectedCycle);
      }

      const selectedType = typeOption.find(
        (option) => option.value === responseData.data.kraTypeId
      );
      if (selectedType) {
        setType(selectedType);
      }
    }
  };

  useEffect(() => {
    debugger;
    if (state && state.id > 0) {
      fetchKRADetails(
        state.id,
        RoleIdArray,
        appCycleOption,
        typeOption,
        employeeOption
      );
    }
    const selectedEmp = employeeOption.find(
      (option) => option.value === Number(EmployeeId)
    );
    switch (true) {
      case RoleIdArray.includes("3") &&
        employeeOption.length > 0 &&
        selectedEmp !== undefined:
        setEmployee(selectedEmp);
        setIsDisable(false);
        break;
      case RoleIdArray.includes("8") &&
        employeeOption.length > 0 &&
        selectedEmp !== undefined:
        setEmployee(selectedEmp);
        setIsDisable(true);
        break;
      case selectedEmp !== undefined:
        setEmployee(selectedEmp);
        setIsDisable(false);
        break;
      default:
        break;
    }
    hideLoader();
  }, [appCycleOption, typeOption, employeeOption]);

  // useEffect(() => {
  //   if (state && state.id > 0) {
  //     const getKRADetailsById = async () => {
  //       const responseData = await APICall(GetKRADetailsBasedOnId, "POST", {
  //         Id: state.id,
  //       });
  //       if (responseData.status === 0 && responseData.data !== null) {
  //         setKraTitle(responseData.data.kraHeading);
  //         setDescription(responseData.data.kraDescription);
  //         setIsActive(responseData.data.isActive);
  //         //Employee Start
  //         const selectedEmp = employeeOption.find(
  //           (option) => option.value === responseData.data.employeeId
  //         );
  //         if (
  //           (selectedEmp && RoleIdArray.includes("3")) ||
  //           RoleIdArray.includes("4")
  //         ) {
  //           setEmployee(selectedEmp);
  //           setIsDisable(false);
  //         } else if (selectedEmp && RoleIdArray.includes("8")) {
  //           setEmployee(selectedEmp);
  //           setIsDisable(true);
  //         }
  //         //Employee End
  //         const selectedCycle = appCycleOption.find(
  //           (option) => option.value === responseData.data.appraisalCycleId
  //         );
  //         if (selectedCycle) {
  //           setAppCycle(selectedCycle);
  //         }
  //         const selectedType = typeOption.find(
  //           (option) => option.value === responseData.data.kraTypeId
  //         );
  //         if (selectedType) {
  //           setType(selectedType); // Sets the selected value
  //         }
  //       }
  //     };
  //     getKRADetailsById();
  //   }
  // }, [appCycleOption, typeOption, employeeOption]);

  const EmployeeDropdown = async () => {
    showLoader();
    let postObject = {
      searchFor: "employee",
      searchValue: 1,
    };
    let x = {};
    const { data } = await APICall(GetDropDownList, "POST", postObject);
    if (data != undefined || data != null) {
      let employees = [];
      await data.map((approver: any) => {
        let tempObj = {
          eid: approver.eid,
          value: approver.id,
          label: approver.name,
        };
        if (approver.id === Number(EmployeeId)) {
          x = {
            eid: approver.eid,
            value: approver.id,
            label: approver.name,
          };
        }
        employees.push(tempObj);
      });

      setEmployeeOption(employees);
      hideLoader();
    }
  };

  const ApprisalDropdown = async () => {
    const responseData = await APICall(GetAppLifeCycDropDown, "POST", {});
    if (responseData.data.length > 0) {
      const ApprisalCycle = responseData.data.map((app) => ({
        value: app.value,
        label: app.label,
      }));

      setAppCycleOption(ApprisalCycle);
    }
  };

  const typeDropdown = async () => {
    const responseData = await APICall(GetKraTypeDropdownData, "POST", {});
    if (responseData.data.length > 0) {
      const KRATypes = responseData.data.map((app) => ({
        value: app.value,
        label: app.label,
      }));

      setTypeOption(KRATypes);
    }
  };

  const selectOnChange = async (event: any, apiFieldName: any) => {
    if (apiFieldName === "employee") {
      if (event && event.value) {
        setEmployee(event);
        setFormErrors((preState) => ({
          ...preState,
          ["Employee_isEmpty"]: undefined,
        }));
      }
    }
    if (apiFieldName === "type") {
      if (event && event.value) {
        setType(event);
        setFormErrors((preState) => ({
          ...preState,
          ["Type_isEmpty"]: undefined,
        }));
      }
    }
    if (apiFieldName === "appCycle") {
      if (event && event.value) {
        setAppCycle(event);
        setFormErrors((preState) => ({
          ...preState,
          ["AppCycle_isEmpty"]: undefined,
        }));
      }
    }
  };

  let formErrorObj = {};

  const handleTextEvent = async (event: any, apiFieldName: any) => {
    if (apiFieldName === "kraTitle") {
      setKraTitle(event.target.value);
      if (
        event.target.value &&
        event.target.value !== "" &&
        event.target.value.trim() !== ""
      ) {
        setFormErrors((preState) => ({
          ...preState,
          ["Title_isEmpty"]: undefined,
        }));
        formErrorObj["Title_isEmpty"] = undefined;
      } else if (
        !event.target.value ||
        event.target.value === "" ||
        event.target.value.trim() === ""
      ) {
        setFormErrors((preState) => ({
          ...preState,
          ["Title_isEmpty"]: "KRA title can not be empty",
        }));
        formErrorObj["Title_isEmpty"] = "KRA title can not be empty";
      }
    }

    if (apiFieldName === "Description") {
      setDescription(event.target.value);
      if (
        event.target.value &&
        event.target.value !== "" &&
        event.target.value.trim() !== ""
      ) {
        setFormErrors((preState) => ({
          ...preState,
          ["Description_isEmpty"]: undefined,
        }));
        formErrorObj["Description_isEmpty"] = undefined;
      } else if (
        !event.target.value ||
        event.target.value === "" ||
        event.target.value.trim() === ""
      ) {
        setFormErrors((preState) => ({
          ...preState,
          ["Description_isEmpty"]: "Description can not be empty",
        }));
        formErrorObj["Description_isEmpty"] = "Description can not be empty";
      }
    }
  };

  const checkValidations = async () => {
    var objError = {};
    if (!employee || employee === null || employee === undefined) {
      objError["Employee_isEmpty"] = "Employee selection is required.";
    }

    if (!type || type === null || type === undefined) {
      objError["Type_isEmpty"] = "Type selection is required.";
    }

    if (!appCycle || appCycle === null || appCycle === undefined) {
      objError["AppCycle_isEmpty"] = "Appraisal Cycle selection is required.";
    }

    if (kraTitle == undefined || kraTitle == null || kraTitle.trim() === "") {
      objError["Title_isEmpty"] = "Title to cannot be empty";
    }
    if (kraTitle == undefined || kraTitle == null || kraTitle.trim() === "") {
      objError["Title_isEmpty"] = "Title to cannot be empty";
    }
    if (
      Description == undefined ||
      Description == null ||
      Description.trim() === ""
    ) {
      objError["Description_isEmpty"] = "Description to cannot be empty";
    }
    formErrorObj = objError;
    await setFormErrors(objError);
  };

  const onClickFunction = async (action) => {
    if (action === "submit") {
      await checkValidations();
      const isEmpty = await Object.values(formErrorObj).every(
        (x) => x === null || x === "" || x == undefined
      );
      if (isEmpty) {
        // setDisabled(true);
        let submitObj = {
          Id: state.id ? state.id : 0,
          AppraisalCycleId: appCycle.value,
          EmpId: employee.value, //state.employeeId,
          KRATypeId: type.value,
          KRAHeading: kraTitle,
          KRADescription: Description,
          isActive: state.id === 0 ? true : isActive,
          CreatedBy: EmployeeId,
        };
        const { data, message } = await APICall(
          InsertKRADetails,
          "POST",
          submitObj
        );
        if (message === "ok") {
          notify(0, "KRA Details Saved Successfully");
          navigate(`${env}/rating/kraRating`, { state: "false" });
        } else {
          notify(1, "KRA Details are Failed");
        }
      }
    }

    if (action === "reset") {
      setFormErrors({});
      setKraTitle("");
      setDescription("");
      setAppCycle("");
      // setAppCycleOption([]);
      setType("");
      // setTypeOption([]);
      if (RoleIdArray.includes["3"] || RoleIdArray.includes["4"]) {
        setEmployee("");
        // setEmployeeOption([]);
      }
    }
  };

  return (
    <>
      <Heading title={"KRA Details"} />
      <div className="container-fluid">
        <div className="row">
          {/* Appraisal cycle */}
          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group">
              <label>
                Appraisal Cycle <sup>*</sup>
              </label>
              <SelectForm
                options={appCycleOption}
                placeholder="Select"
                isDisabled={false}
                value={appCycle}
                onChange={(event) => selectOnChange(event, "appCycle")}
                isMulti={false}
                noIndicator={false}
                noSeparator={false}
              />
              <p style={{ color: "red" }}>{formErrors["AppCycle_isEmpty"]}</p>
            </div>
          </div>
          {/* Employee */}
          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group">
              <label>
                Employee <sup>*</sup>
              </label>
              <SelectForm
                options={employeeOption}
                placeholder="Select"
                isDisabled={isDisable}
                value={employee}
                onChange={(event) => selectOnChange(event, "employee")}
                isMulti={false}
                noIndicator={false}
                noSeparator={false}
              />
              <p style={{ color: "red" }}>{formErrors["Employee_isEmpty"]}</p>
            </div>
          </div>
          {/* Type */}
          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group">
              <label>
                Type <sup>*</sup>
              </label>
              <SelectForm
                options={typeOption}
                placeholder="Select"
                isDisabled={false}
                value={type}
                onChange={(event) => selectOnChange(event, "type")}
                isMulti={false}
                noIndicator={false}
                noSeparator={false}
              />
              <p style={{ color: "red" }}>{formErrors["Type_isEmpty"]}</p>
            </div>
          </div>
          {/* KRA Title */}
          <div className="col-lg-12">
            <div className="form-group">
              <label>
                KRA Title <sup>*</sup>
              </label>
              <InputForm
                placeholder={""}
                isDisabled={false}
                textArea={false}
                value={kraTitle}
                onChange={(event) => handleTextEvent(event, "kraTitle")}
              />

              <p style={{ color: "red" }}>{formErrors["Title_isEmpty"]}</p>
            </div>
          </div>
          {/* KRA Descriptoin */}
          <div className="col-lg-12">
            <div className="form-group">
              <label>
                KRA Description <sup>*</sup>
              </label>
              <InputForm
                placeholder={"Add KRA Description"}
                isDisabled={false}
                textArea={true}
                value={Description}
                rows={4}
                onChange={(event) => handleTextEvent(event, "Description")}
              />
              <p style={{ color: "red" }}>
                {formErrors["Description_isEmpty"]}
              </p>
            </div>
          </div>
          {state.id > 0 && (
            <div className="col-lg-4 col-md-4 col-sm-6">
              <div className="form-group">
                <label htmlFor="isActive" className="mr-2">
                  Is Active
                </label>
                <input
                  id="isActive"
                  type="checkbox"
                  onChange={(e) => setIsActive(e.target.checked)}
                  name="isActive"
                  checked={isActive}
                />
              </div>
            </div>
          )}
          <div className="col-lg-12">
            <div className="d-flex justify-content-between">
              <div>
                <button
                  onClick={() => {
                    // navigate(-1)
                    navigate(`${env}/rating/kraRating`, {
                      state: {
                        appraisalCycle: appCycle, // Pass the selected value
                      },
                    });
                  }}
                  className="btn btn-reset"
                >
                  <i className="fa fa-chevron-left"></i>
                </button>
              </div>
              <div className="d-flex gap-2">
                <button
                  onClick={() => onClickFunction("reset")}
                  className="btn btn-reset"
                >
                  Reset
                </button>

                <button
                  onClick={() => onClickFunction("submit")}
                  className="btn btn-submit"
                  // disabled={gridData.length === 0}
                  //   disabled={disabled}
                >
                  {state.id === 0 ? "Submit" : "Update"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default KRAMaster;
